// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".advantage__image[data-v-772044c4]{width:100%;aspect-ratio:305/289}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
